const { LocaleUtil } = await import("uidispatcher_api/UidispatcherApiModule");
export default LocaleUtil;
